import { computed, ref } from 'vue'
import { authenticationWithEmail, changePassword, getActivities, getProfile } from '@/modules/session/api'
import { AuthenticationRequest, Profile } from '@/modules/session/types'
import { HistoryRecord } from '@/modules/_shared/audit-log/types'

export * from './types'

function isProfile (rawObject: unknown): rawObject is Profile {
    const profileCandidate = rawObject as Profile
    return profileCandidate.id !== undefined &&
        profileCandidate.firstName !== undefined &&
        profileCandidate.lastName !== undefined &&
        profileCandidate.email !== undefined &&
        Array.isArray(profileCandidate.roles)
}

function storageToProfile (storageString: string | null): Profile | undefined {
    if (!storageString) {
        return undefined
    }
    const obj = JSON.parse(storageString)
    if (isProfile(obj)) {
        return obj
    }

    return undefined
}

const activities = ref<HistoryRecord[]>([])
const token = ref(window.localStorage.getItem('token') || null)
const profile = ref(storageToProfile(window.localStorage.getItem('profile')))

function logIn (newToken: string): void {
    window.localStorage.setItem('token', newToken)
    token.value = newToken
}

function logOut () {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('profile')
    token.value = null
}

async function loadProfile () {
    profile.value = await getProfile()
    activities.value = await getActivities()
    window.localStorage.setItem('profile', JSON.stringify(profile.value))
}

const authenticateWithPassword = async (data: AuthenticationRequest) => {
    await authenticationWithEmail(data).then(logIn).then(loadProfile)
}

const isOperatorSecurityAdmin = computed(() => {
    return profile.value && profile.value.roles.map(r => r.key).includes('security_admin')
})

const isOperatorInvoicingManager = computed(() => {
    return profile.value && profile.value.roles.map(r => r.key).includes('invoicing_manager')
})

export function useSessionModule () {
    return {
        authenticateWithPassword,
        logOut,
        loadProfile,
        activities,
        profile: computed(() => profile.value),
        changePassword,
        token: computed(() => token.value),
        isLoggedIn: computed(() => token.value),
        isOperatorSecurityAdmin,
        isOperatorInvoicingManager
    }
}
